const translateHowToPlay = {
    en: {
        howToPlayComponent: {
            howToPlay: "How to play?",
            step01: "Make a bet, or even two at same time and wait for the round to start.",
            step02: "Look after the lucky plane. Your win is bet multiplied by a coefficient of lucky plane.",
            step03: "Cash Out before plane flies away and money is yours!",
            detailedRules: "detailed rules",
        },
    },
    ru: {
        howToPlayComponent: {
            howToPlay: "Как играть?",
            step01: "Сделайте ставку или даже две сразу и дождись начала раунда.",
            step02: "Следите за самолетом удачи. Ваш выигрыш – это ставка, умноженная на множитель самолета удачи.",
            step03: "Выведите средства до того, как самолет улетит, и деньги будут вашими!",
            detailedRules: "подробные правила",
        },
    },
    uz: {
        howToPlayComponent: {
            howToPlay: "Qanday o'ynaladi?",
            step01: "Bir marta yoki bir vaqtning oʻzida ikki marta pul tikib, raund boshlanishini kuting.",
            step02: "Omadli Samolyotni kuzating. Sizning yutugʻingiz Omadli Samolyot koeffitsientiga koʻpaytiriladi.",
            step03: "Samolyot uchib ketgunga qadar pulni oling va pul sizniki!",
            detailedRules: "batafsil qoidalar",
        },
    }
}

export default translateHowToPlay;